var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{staticClass:"mt-0 pt-0",attrs:{"dense":"","hide-details":"","label":_vm.label},model:{value:(_vm.isSwitchOn),callback:function ($$v) {_vm.isSwitchOn=$$v},expression:"isSwitchOn"}})}
var staticRenderFns = []

export { render, staticRenderFns }